import { get as X, set as H, appendErrors as Ae } from "react-hook-form";
import { useState as Ne, useCallback as Ze } from "react";
const ie = (s, e, t) => {
  if (s && "reportValidity" in s) {
    const r = X(t, e);
    s.setCustomValidity(r && r.message || ""), s.reportValidity();
  }
}, be = (s, e) => {
  for (const t in e.fields) {
    const r = e.fields[t];
    r && r.ref && "reportValidity" in r.ref ? ie(r.ref, t, s) : r && r.refs && r.refs.forEach((a) => ie(a, t, s));
  }
}, Re = (s, e) => {
  e.shouldUseNativeValidation && be(s, e);
  const t = {};
  for (const r in s) {
    const a = X(e.fields, r), n = Object.assign(s[r] || {}, { ref: a && a.ref });
    if (Ee(e.names || Object.keys(s), r)) {
      const i = Object.assign({}, X(t, r));
      H(i, "root", n), H(t, r, i);
    } else H(t, r, n);
  }
  return t;
}, Ee = (s, e) => {
  const t = de(e);
  return s.some((r) => de(r).match(`^${t}\\.\\d+`));
};
function de(s) {
  return s.replace(/\]|\[/g, "");
}
function je(s, e) {
  for (var t = {}; s.length; ) {
    var r = s[0], a = r.code, n = r.message, i = r.path.join(".");
    if (!t[i]) if ("unionErrors" in r) {
      var d = r.unionErrors[0].errors[0];
      t[i] = { message: d.message, type: d.code };
    } else t[i] = { message: n, type: a };
    if ("unionErrors" in r && r.unionErrors.forEach(function(y) {
      return y.errors.forEach(function(Z) {
        return s.push(Z);
      });
    }), e) {
      var u = t[i].types, f = u && u[r.code];
      t[i] = Ae(i, e, t, a, f ? [].concat(f, r.message) : r.message);
    }
    s.shift();
  }
  return t;
}
function ct(s, e, t) {
  return t === void 0 && (t = {}), function(r, a, n) {
    try {
      return Promise.resolve(function(i, d) {
        try {
          var u = Promise.resolve(s[t.mode === "sync" ? "parse" : "parseAsync"](r, e)).then(function(f) {
            return n.shouldUseNativeValidation && be({}, n), { errors: {}, values: t.raw ? Object.assign({}, r) : f };
          });
        } catch (f) {
          return d(f);
        }
        return u && u.then ? u.then(void 0, d) : u;
      }(0, function(i) {
        if (function(d) {
          return Array.isArray(d == null ? void 0 : d.errors);
        }(i)) return { values: {}, errors: Re(je(i.errors, !n.shouldUseNativeValidation && n.criteriaMode === "all"), n) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
}
const Ie = 10, ut = 20, lt = () => {
  const [s, e] = Ne({
    active: !1,
    label: ""
  }), t = Ze(
    (r, a = "success", n = Ie) => {
      e({ label: r, kind: a, active: !0 });
      const i = setTimeout(() => {
        e((d) => ({ ...d, active: !1 }));
      }, n * 1e3);
      return () => clearTimeout(i);
    },
    []
  );
  return { snackbarProps: s, showSnackbar: t };
};
var v;
(function(s) {
  s.assertEqual = (a) => {
  };
  function e(a) {
  }
  s.assertIs = e;
  function t(a) {
    throw new Error();
  }
  s.assertNever = t, s.arrayToEnum = (a) => {
    const n = {};
    for (const i of a)
      n[i] = i;
    return n;
  }, s.getValidEnumValues = (a) => {
    const n = s.objectKeys(a).filter((d) => typeof a[a[d]] != "number"), i = {};
    for (const d of n)
      i[d] = a[d];
    return s.objectValues(i);
  }, s.objectValues = (a) => s.objectKeys(a).map(function(n) {
    return a[n];
  }), s.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const n = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && n.push(i);
    return n;
  }, s.find = (a, n) => {
    for (const i of a)
      if (n(i))
        return i;
  }, s.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function r(a, n = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(n);
  }
  s.joinValues = r, s.jsonStringifyReplacer = (a, n) => typeof n == "bigint" ? n.toString() : n;
})(v || (v = {}));
var oe;
(function(s) {
  s.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(oe || (oe = {}));
const l = v.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), T = (s) => {
  switch (typeof s) {
    case "undefined":
      return l.undefined;
    case "string":
      return l.string;
    case "number":
      return Number.isNaN(s) ? l.nan : l.number;
    case "boolean":
      return l.boolean;
    case "function":
      return l.function;
    case "bigint":
      return l.bigint;
    case "symbol":
      return l.symbol;
    case "object":
      return Array.isArray(s) ? l.array : s === null ? l.null : s.then && typeof s.then == "function" && s.catch && typeof s.catch == "function" ? l.promise : typeof Map < "u" && s instanceof Map ? l.map : typeof Set < "u" && s instanceof Set ? l.set : typeof Date < "u" && s instanceof Date ? l.date : l.object;
    default:
      return l.unknown;
  }
}, o = v.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class C extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(n) {
      return n.message;
    }, r = { _errors: [] }, a = (n) => {
      for (const i of n.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          r._errors.push(t(i));
        else {
          let d = r, u = 0;
          for (; u < i.path.length; ) {
            const f = i.path[u];
            u === i.path.length - 1 ? (d[f] = d[f] || { _errors: [] }, d[f]._errors.push(t(i))) : d[f] = d[f] || { _errors: [] }, d = d[f], u++;
          }
        }
    };
    return a(this), r;
  }
  static assert(e) {
    if (!(e instanceof C))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, v.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, r = [];
    for (const a of this.issues)
      a.path.length > 0 ? (t[a.path[0]] = t[a.path[0]] || [], t[a.path[0]].push(e(a))) : r.push(e(a));
    return { formErrors: r, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
C.create = (s) => new C(s);
const Q = (s, e) => {
  let t;
  switch (s.code) {
    case o.invalid_type:
      s.received === l.undefined ? t = "Required" : t = `Expected ${s.expected}, received ${s.received}`;
      break;
    case o.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(s.expected, v.jsonStringifyReplacer)}`;
      break;
    case o.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${v.joinValues(s.keys, ", ")}`;
      break;
    case o.invalid_union:
      t = "Invalid input";
      break;
    case o.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${v.joinValues(s.options)}`;
      break;
    case o.invalid_enum_value:
      t = `Invalid enum value. Expected ${v.joinValues(s.options)}, received '${s.received}'`;
      break;
    case o.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case o.invalid_return_type:
      t = "Invalid function return type";
      break;
    case o.invalid_date:
      t = "Invalid date";
      break;
    case o.invalid_string:
      typeof s.validation == "object" ? "includes" in s.validation ? (t = `Invalid input: must include "${s.validation.includes}"`, typeof s.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${s.validation.position}`)) : "startsWith" in s.validation ? t = `Invalid input: must start with "${s.validation.startsWith}"` : "endsWith" in s.validation ? t = `Invalid input: must end with "${s.validation.endsWith}"` : v.assertNever(s.validation) : s.validation !== "regex" ? t = `Invalid ${s.validation}` : t = "Invalid";
      break;
    case o.too_small:
      s.type === "array" ? t = `Array must contain ${s.exact ? "exactly" : s.inclusive ? "at least" : "more than"} ${s.minimum} element(s)` : s.type === "string" ? t = `String must contain ${s.exact ? "exactly" : s.inclusive ? "at least" : "over"} ${s.minimum} character(s)` : s.type === "number" ? t = `Number must be ${s.exact ? "exactly equal to " : s.inclusive ? "greater than or equal to " : "greater than "}${s.minimum}` : s.type === "date" ? t = `Date must be ${s.exact ? "exactly equal to " : s.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(s.minimum))}` : t = "Invalid input";
      break;
    case o.too_big:
      s.type === "array" ? t = `Array must contain ${s.exact ? "exactly" : s.inclusive ? "at most" : "less than"} ${s.maximum} element(s)` : s.type === "string" ? t = `String must contain ${s.exact ? "exactly" : s.inclusive ? "at most" : "under"} ${s.maximum} character(s)` : s.type === "number" ? t = `Number must be ${s.exact ? "exactly" : s.inclusive ? "less than or equal to" : "less than"} ${s.maximum}` : s.type === "bigint" ? t = `BigInt must be ${s.exact ? "exactly" : s.inclusive ? "less than or equal to" : "less than"} ${s.maximum}` : s.type === "date" ? t = `Date must be ${s.exact ? "exactly" : s.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(s.maximum))}` : t = "Invalid input";
      break;
    case o.custom:
      t = "Invalid input";
      break;
    case o.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case o.not_multiple_of:
      t = `Number must be a multiple of ${s.multipleOf}`;
      break;
    case o.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, v.assertNever(s);
  }
  return { message: t };
};
let $e = Q;
function Ve() {
  return $e;
}
const Pe = (s) => {
  const { data: e, path: t, errorMaps: r, issueData: a } = s, n = [...t, ...a.path || []], i = {
    ...a,
    path: n
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: n,
      message: a.message
    };
  let d = "";
  const u = r.filter((f) => !!f).slice().reverse();
  for (const f of u)
    d = f(i, { data: e, defaultError: d }).message;
  return {
    ...a,
    path: n,
    message: d
  };
};
function c(s, e) {
  const t = Ve(), r = Pe({
    issueData: e,
    data: s.data,
    path: s.path,
    errorMaps: [
      s.common.contextualErrorMap,
      // contextual error map is first priority
      s.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === Q ? void 0 : Q
      // then global default map
    ].filter((a) => !!a)
  });
  s.common.issues.push(r);
}
class k {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const r = [];
    for (const a of t) {
      if (a.status === "aborted")
        return p;
      a.status === "dirty" && e.dirty(), r.push(a.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, t) {
    const r = [];
    for (const a of t) {
      const n = await a.key, i = await a.value;
      r.push({
        key: n,
        value: i
      });
    }
    return k.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, t) {
    const r = {};
    for (const a of t) {
      const { key: n, value: i } = a;
      if (n.status === "aborted" || i.status === "aborted")
        return p;
      n.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), n.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (r[n.value] = i.value);
    }
    return { status: e.value, value: r };
  }
}
const p = Object.freeze({
  status: "aborted"
}), P = (s) => ({ status: "dirty", value: s }), b = (s) => ({ status: "valid", value: s }), ce = (s) => s.status === "aborted", ue = (s) => s.status === "dirty", j = (s) => s.status === "valid", B = (s) => typeof Promise < "u" && s instanceof Promise;
var h;
(function(s) {
  s.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, s.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(h || (h = {}));
var F = function(s, e, t, r) {
  if (t === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? s !== e || !r : !e.has(s)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? r : t === "a" ? r.call(s) : r ? r.value : e.get(s);
}, we = function(s, e, t, r, a) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? s !== e || !a : !e.has(s)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? a.call(s, t) : a ? a.value = t : e.set(s, t), t;
}, M, L;
class A {
  constructor(e, t, r, a) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = r, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const le = (s, e) => {
  if (j(e))
    return { success: !0, data: e.value };
  if (!s.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new C(s.common.issues);
      return this._error = t, this._error;
    }
  };
};
function _(s) {
  if (!s)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: r, description: a } = s;
  if (e && (t || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (i, d) => {
    const { message: u } = s;
    return i.code === "invalid_enum_value" ? { message: u ?? d.defaultError } : typeof d.data > "u" ? { message: u ?? r ?? d.defaultError } : i.code !== "invalid_type" ? { message: d.defaultError } : { message: u ?? t ?? d.defaultError };
  }, description: a };
}
class g {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return T(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: T(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new k(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: T(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (B(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const r = this.safeParse(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, t) {
    const r = {
      common: {
        issues: [],
        async: (t == null ? void 0 : t.async) ?? !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: T(e)
    }, a = this._parseSync({ data: e, path: r.path, parent: r });
    return le(r, a);
  }
  "~validate"(e) {
    var r, a;
    const t = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: T(e)
    };
    if (!this["~standard"].async)
      try {
        const n = this._parseSync({ data: e, path: [], parent: t });
        return j(n) ? {
          value: n.value
        } : {
          issues: t.common.issues
        };
      } catch (n) {
        (a = (r = n == null ? void 0 : n.message) == null ? void 0 : r.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), t.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: t }).then((n) => j(n) ? {
      value: n.value
    } : {
      issues: t.common.issues
    });
  }
  async parseAsync(e, t) {
    const r = await this.safeParseAsync(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, t) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: T(e)
    }, a = this._parse({ data: e, path: r.path, parent: r }), n = await (B(a) ? a : Promise.resolve(a));
    return le(r, n);
  }
  refine(e, t) {
    const r = (a) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(a) : t;
    return this._refinement((a, n) => {
      const i = e(a), d = () => n.addIssue({
        code: o.custom,
        ...r(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => u ? !0 : (d(), !1)) : i ? !0 : (d(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((r, a) => e(r) ? !0 : (a.addIssue(typeof t == "function" ? t(r, a) : t), !1));
  }
  _refinement(e) {
    return new $({
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return S.create(this, this._def);
  }
  nullable() {
    return V.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return w.create(this);
  }
  promise() {
    return G.create(this, this._def);
  }
  or(e) {
    return q.create([this, e], this._def);
  }
  and(e) {
    return J.create(this, e, this._def);
  }
  transform(e) {
    return new $({
      ..._(this._def),
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new re({
      ..._(this._def),
      innerType: this,
      defaultValue: t,
      typeName: m.ZodDefault
    });
  }
  brand() {
    return new it({
      typeName: m.ZodBranded,
      type: this,
      ..._(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new se({
      ..._(this._def),
      innerType: this,
      catchValue: t,
      typeName: m.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return ne.create(this, e);
  }
  readonly() {
    return ae.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Me = /^c[^\s-]{8,}$/i, Le = /^[0-9a-z]+$/, ze = /^[0-9A-HJKMNP-TV-Z]{26}$/i, De = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ue = /^[a-z0-9_-]{21}$/i, Be = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Fe = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, We = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, qe = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Y;
const Je = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ge = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, He = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Ye = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Xe = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Qe = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ce = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ke = new RegExp(`^${Ce}$`);
function Te(s) {
  let e = "[0-5]\\d";
  s.precision ? e = `${e}\\.\\d{${s.precision}}` : s.precision == null && (e = `${e}(\\.\\d+)?`);
  const t = s.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`;
}
function et(s) {
  return new RegExp(`^${Te(s)}$`);
}
function tt(s) {
  let e = `${Ce}T${Te(s)}`;
  const t = [];
  return t.push(s.local ? "Z?" : "Z"), s.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function rt(s, e) {
  return !!((e === "v4" || !e) && Je.test(s) || (e === "v6" || !e) && He.test(s));
}
function st(s, e) {
  if (!Be.test(s))
    return !1;
  try {
    const [t] = s.split("."), r = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), a = JSON.parse(atob(r));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function at(s, e) {
  return !!((e === "v4" || !e) && Ge.test(s) || (e === "v6" || !e) && Ye.test(s));
}
class O extends g {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== l.string) {
      const n = this._getOrReturnCtx(e);
      return c(n, {
        code: o.invalid_type,
        expected: l.string,
        received: n.parsedType
      }), p;
    }
    const r = new k();
    let a;
    for (const n of this._def.checks)
      if (n.kind === "min")
        e.data.length < n.value && (a = this._getOrReturnCtx(e, a), c(a, {
          code: o.too_small,
          minimum: n.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: n.message
        }), r.dirty());
      else if (n.kind === "max")
        e.data.length > n.value && (a = this._getOrReturnCtx(e, a), c(a, {
          code: o.too_big,
          maximum: n.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: n.message
        }), r.dirty());
      else if (n.kind === "length") {
        const i = e.data.length > n.value, d = e.data.length < n.value;
        (i || d) && (a = this._getOrReturnCtx(e, a), i ? c(a, {
          code: o.too_big,
          maximum: n.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: n.message
        }) : d && c(a, {
          code: o.too_small,
          minimum: n.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: n.message
        }), r.dirty());
      } else if (n.kind === "email")
        We.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
          validation: "email",
          code: o.invalid_string,
          message: n.message
        }), r.dirty());
      else if (n.kind === "emoji")
        Y || (Y = new RegExp(qe, "u")), Y.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
          validation: "emoji",
          code: o.invalid_string,
          message: n.message
        }), r.dirty());
      else if (n.kind === "uuid")
        De.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
          validation: "uuid",
          code: o.invalid_string,
          message: n.message
        }), r.dirty());
      else if (n.kind === "nanoid")
        Ue.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
          validation: "nanoid",
          code: o.invalid_string,
          message: n.message
        }), r.dirty());
      else if (n.kind === "cuid")
        Me.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
          validation: "cuid",
          code: o.invalid_string,
          message: n.message
        }), r.dirty());
      else if (n.kind === "cuid2")
        Le.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
          validation: "cuid2",
          code: o.invalid_string,
          message: n.message
        }), r.dirty());
      else if (n.kind === "ulid")
        ze.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
          validation: "ulid",
          code: o.invalid_string,
          message: n.message
        }), r.dirty());
      else if (n.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), c(a, {
            validation: "url",
            code: o.invalid_string,
            message: n.message
          }), r.dirty();
        }
      else n.kind === "regex" ? (n.regex.lastIndex = 0, n.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
        validation: "regex",
        code: o.invalid_string,
        message: n.message
      }), r.dirty())) : n.kind === "trim" ? e.data = e.data.trim() : n.kind === "includes" ? e.data.includes(n.value, n.position) || (a = this._getOrReturnCtx(e, a), c(a, {
        code: o.invalid_string,
        validation: { includes: n.value, position: n.position },
        message: n.message
      }), r.dirty()) : n.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : n.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : n.kind === "startsWith" ? e.data.startsWith(n.value) || (a = this._getOrReturnCtx(e, a), c(a, {
        code: o.invalid_string,
        validation: { startsWith: n.value },
        message: n.message
      }), r.dirty()) : n.kind === "endsWith" ? e.data.endsWith(n.value) || (a = this._getOrReturnCtx(e, a), c(a, {
        code: o.invalid_string,
        validation: { endsWith: n.value },
        message: n.message
      }), r.dirty()) : n.kind === "datetime" ? tt(n).test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
        code: o.invalid_string,
        validation: "datetime",
        message: n.message
      }), r.dirty()) : n.kind === "date" ? Ke.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
        code: o.invalid_string,
        validation: "date",
        message: n.message
      }), r.dirty()) : n.kind === "time" ? et(n).test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
        code: o.invalid_string,
        validation: "time",
        message: n.message
      }), r.dirty()) : n.kind === "duration" ? Fe.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
        validation: "duration",
        code: o.invalid_string,
        message: n.message
      }), r.dirty()) : n.kind === "ip" ? rt(e.data, n.version) || (a = this._getOrReturnCtx(e, a), c(a, {
        validation: "ip",
        code: o.invalid_string,
        message: n.message
      }), r.dirty()) : n.kind === "jwt" ? st(e.data, n.alg) || (a = this._getOrReturnCtx(e, a), c(a, {
        validation: "jwt",
        code: o.invalid_string,
        message: n.message
      }), r.dirty()) : n.kind === "cidr" ? at(e.data, n.version) || (a = this._getOrReturnCtx(e, a), c(a, {
        validation: "cidr",
        code: o.invalid_string,
        message: n.message
      }), r.dirty()) : n.kind === "base64" ? Xe.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
        validation: "base64",
        code: o.invalid_string,
        message: n.message
      }), r.dirty()) : n.kind === "base64url" ? Qe.test(e.data) || (a = this._getOrReturnCtx(e, a), c(a, {
        validation: "base64url",
        code: o.invalid_string,
        message: n.message
      }), r.dirty()) : v.assertNever(n);
    return { status: r.value, value: e.data };
  }
  _regex(e, t, r) {
    return this.refinement((a) => e.test(a), {
      validation: t,
      code: o.invalid_string,
      ...h.errToObj(r)
    });
  }
  _addCheck(e) {
    return new O({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...h.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...h.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...h.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...h.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...h.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...h.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...h.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...h.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...h.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...h.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...h.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...h.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...h.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...h.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...h.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...h.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...h.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ...h.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...h.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...h.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...h.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...h.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...h.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, h.errToObj(e));
  }
  trim() {
    return new O({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new O({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new O({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
O.create = (s) => new O({
  checks: [],
  typeName: m.ZodString,
  coerce: (s == null ? void 0 : s.coerce) ?? !1,
  ..._(s)
});
function nt(s, e) {
  const t = (s.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, a = t > r ? t : r, n = Number.parseInt(s.toFixed(a).replace(".", "")), i = Number.parseInt(e.toFixed(a).replace(".", ""));
  return n % i / 10 ** a;
}
class z extends g {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== l.number) {
      const n = this._getOrReturnCtx(e);
      return c(n, {
        code: o.invalid_type,
        expected: l.number,
        received: n.parsedType
      }), p;
    }
    let r;
    const a = new k();
    for (const n of this._def.checks)
      n.kind === "int" ? v.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), c(r, {
        code: o.invalid_type,
        expected: "integer",
        received: "float",
        message: n.message
      }), a.dirty()) : n.kind === "min" ? (n.inclusive ? e.data < n.value : e.data <= n.value) && (r = this._getOrReturnCtx(e, r), c(r, {
        code: o.too_small,
        minimum: n.value,
        type: "number",
        inclusive: n.inclusive,
        exact: !1,
        message: n.message
      }), a.dirty()) : n.kind === "max" ? (n.inclusive ? e.data > n.value : e.data >= n.value) && (r = this._getOrReturnCtx(e, r), c(r, {
        code: o.too_big,
        maximum: n.value,
        type: "number",
        inclusive: n.inclusive,
        exact: !1,
        message: n.message
      }), a.dirty()) : n.kind === "multipleOf" ? nt(e.data, n.value) !== 0 && (r = this._getOrReturnCtx(e, r), c(r, {
        code: o.not_multiple_of,
        multipleOf: n.value,
        message: n.message
      }), a.dirty()) : n.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), c(r, {
        code: o.not_finite,
        message: n.message
      }), a.dirty()) : v.assertNever(n);
    return { status: a.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, h.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, h.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, h.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, h.toString(t));
  }
  setLimit(e, t, r, a) {
    return new z({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: h.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new z({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: h.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: h.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: h.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: h.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: h.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: h.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: h.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: h.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: h.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && v.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (t === null || r.value > t) && (t = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
z.create = (s) => new z({
  checks: [],
  typeName: m.ZodNumber,
  coerce: (s == null ? void 0 : s.coerce) || !1,
  ..._(s)
});
class D extends g {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== l.bigint)
      return this._getInvalidInput(e);
    let r;
    const a = new k();
    for (const n of this._def.checks)
      n.kind === "min" ? (n.inclusive ? e.data < n.value : e.data <= n.value) && (r = this._getOrReturnCtx(e, r), c(r, {
        code: o.too_small,
        type: "bigint",
        minimum: n.value,
        inclusive: n.inclusive,
        message: n.message
      }), a.dirty()) : n.kind === "max" ? (n.inclusive ? e.data > n.value : e.data >= n.value) && (r = this._getOrReturnCtx(e, r), c(r, {
        code: o.too_big,
        type: "bigint",
        maximum: n.value,
        inclusive: n.inclusive,
        message: n.message
      }), a.dirty()) : n.kind === "multipleOf" ? e.data % n.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), c(r, {
        code: o.not_multiple_of,
        multipleOf: n.value,
        message: n.message
      }), a.dirty()) : v.assertNever(n);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return c(t, {
      code: o.invalid_type,
      expected: l.bigint,
      received: t.parsedType
    }), p;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, h.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, h.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, h.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, h.toString(t));
  }
  setLimit(e, t, r, a) {
    return new D({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: h.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new D({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: h.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: h.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: h.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: h.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: h.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
D.create = (s) => new D({
  checks: [],
  typeName: m.ZodBigInt,
  coerce: (s == null ? void 0 : s.coerce) ?? !1,
  ..._(s)
});
class K extends g {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== l.boolean) {
      const r = this._getOrReturnCtx(e);
      return c(r, {
        code: o.invalid_type,
        expected: l.boolean,
        received: r.parsedType
      }), p;
    }
    return b(e.data);
  }
}
K.create = (s) => new K({
  typeName: m.ZodBoolean,
  coerce: (s == null ? void 0 : s.coerce) || !1,
  ..._(s)
});
class W extends g {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== l.date) {
      const n = this._getOrReturnCtx(e);
      return c(n, {
        code: o.invalid_type,
        expected: l.date,
        received: n.parsedType
      }), p;
    }
    if (Number.isNaN(e.data.getTime())) {
      const n = this._getOrReturnCtx(e);
      return c(n, {
        code: o.invalid_date
      }), p;
    }
    const r = new k();
    let a;
    for (const n of this._def.checks)
      n.kind === "min" ? e.data.getTime() < n.value && (a = this._getOrReturnCtx(e, a), c(a, {
        code: o.too_small,
        message: n.message,
        inclusive: !0,
        exact: !1,
        minimum: n.value,
        type: "date"
      }), r.dirty()) : n.kind === "max" ? e.data.getTime() > n.value && (a = this._getOrReturnCtx(e, a), c(a, {
        code: o.too_big,
        message: n.message,
        inclusive: !0,
        exact: !1,
        maximum: n.value,
        type: "date"
      }), r.dirty()) : v.assertNever(n);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new W({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: h.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: h.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
W.create = (s) => new W({
  checks: [],
  coerce: (s == null ? void 0 : s.coerce) || !1,
  typeName: m.ZodDate,
  ..._(s)
});
class fe extends g {
  _parse(e) {
    if (this._getType(e) !== l.symbol) {
      const r = this._getOrReturnCtx(e);
      return c(r, {
        code: o.invalid_type,
        expected: l.symbol,
        received: r.parsedType
      }), p;
    }
    return b(e.data);
  }
}
fe.create = (s) => new fe({
  typeName: m.ZodSymbol,
  ..._(s)
});
class he extends g {
  _parse(e) {
    if (this._getType(e) !== l.undefined) {
      const r = this._getOrReturnCtx(e);
      return c(r, {
        code: o.invalid_type,
        expected: l.undefined,
        received: r.parsedType
      }), p;
    }
    return b(e.data);
  }
}
he.create = (s) => new he({
  typeName: m.ZodUndefined,
  ..._(s)
});
class me extends g {
  _parse(e) {
    if (this._getType(e) !== l.null) {
      const r = this._getOrReturnCtx(e);
      return c(r, {
        code: o.invalid_type,
        expected: l.null,
        received: r.parsedType
      }), p;
    }
    return b(e.data);
  }
}
me.create = (s) => new me({
  typeName: m.ZodNull,
  ..._(s)
});
class pe extends g {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return b(e.data);
  }
}
pe.create = (s) => new pe({
  typeName: m.ZodAny,
  ..._(s)
});
class _e extends g {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return b(e.data);
  }
}
_e.create = (s) => new _e({
  typeName: m.ZodUnknown,
  ..._(s)
});
class N extends g {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return c(t, {
      code: o.invalid_type,
      expected: l.never,
      received: t.parsedType
    }), p;
  }
}
N.create = (s) => new N({
  typeName: m.ZodNever,
  ..._(s)
});
class ye extends g {
  _parse(e) {
    if (this._getType(e) !== l.undefined) {
      const r = this._getOrReturnCtx(e);
      return c(r, {
        code: o.invalid_type,
        expected: l.void,
        received: r.parsedType
      }), p;
    }
    return b(e.data);
  }
}
ye.create = (s) => new ye({
  typeName: m.ZodVoid,
  ..._(s)
});
class w extends g {
  _parse(e) {
    const { ctx: t, status: r } = this._processInputParams(e), a = this._def;
    if (t.parsedType !== l.array)
      return c(t, {
        code: o.invalid_type,
        expected: l.array,
        received: t.parsedType
      }), p;
    if (a.exactLength !== null) {
      const i = t.data.length > a.exactLength.value, d = t.data.length < a.exactLength.value;
      (i || d) && (c(t, {
        code: i ? o.too_big : o.too_small,
        minimum: d ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), r.dirty());
    }
    if (a.minLength !== null && t.data.length < a.minLength.value && (c(t, {
      code: o.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), r.dirty()), a.maxLength !== null && t.data.length > a.maxLength.value && (c(t, {
      code: o.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), r.dirty()), t.common.async)
      return Promise.all([...t.data].map((i, d) => a.type._parseAsync(new A(t, i, t.path, d)))).then((i) => k.mergeArray(r, i));
    const n = [...t.data].map((i, d) => a.type._parseSync(new A(t, i, t.path, d)));
    return k.mergeArray(r, n);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new w({
      ...this._def,
      minLength: { value: e, message: h.toString(t) }
    });
  }
  max(e, t) {
    return new w({
      ...this._def,
      maxLength: { value: e, message: h.toString(t) }
    });
  }
  length(e, t) {
    return new w({
      ...this._def,
      exactLength: { value: e, message: h.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
w.create = (s, e) => new w({
  type: s,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: m.ZodArray,
  ..._(e)
});
function E(s) {
  if (s instanceof x) {
    const e = {};
    for (const t in s.shape) {
      const r = s.shape[t];
      e[t] = S.create(E(r));
    }
    return new x({
      ...s._def,
      shape: () => e
    });
  } else return s instanceof w ? new w({
    ...s._def,
    type: E(s.element)
  }) : s instanceof S ? S.create(E(s.unwrap())) : s instanceof V ? V.create(E(s.unwrap())) : s instanceof R ? R.create(s.items.map((e) => E(e))) : s;
}
class x extends g {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = v.objectKeys(e);
    return this._cached = { shape: e, keys: t }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== l.object) {
      const f = this._getOrReturnCtx(e);
      return c(f, {
        code: o.invalid_type,
        expected: l.object,
        received: f.parsedType
      }), p;
    }
    const { status: r, ctx: a } = this._processInputParams(e), { shape: n, keys: i } = this._getCached(), d = [];
    if (!(this._def.catchall instanceof N && this._def.unknownKeys === "strip"))
      for (const f in a.data)
        i.includes(f) || d.push(f);
    const u = [];
    for (const f of i) {
      const y = n[f], Z = a.data[f];
      u.push({
        key: { status: "valid", value: f },
        value: y._parse(new A(a, Z, a.path, f)),
        alwaysSet: f in a.data
      });
    }
    if (this._def.catchall instanceof N) {
      const f = this._def.unknownKeys;
      if (f === "passthrough")
        for (const y of d)
          u.push({
            key: { status: "valid", value: y },
            value: { status: "valid", value: a.data[y] }
          });
      else if (f === "strict")
        d.length > 0 && (c(a, {
          code: o.unrecognized_keys,
          keys: d
        }), r.dirty());
      else if (f !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const f = this._def.catchall;
      for (const y of d) {
        const Z = a.data[y];
        u.push({
          key: { status: "valid", value: y },
          value: f._parse(
            new A(a, Z, a.path, y)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: y in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const f = [];
      for (const y of u) {
        const Z = await y.key, Se = await y.value;
        f.push({
          key: Z,
          value: Se,
          alwaysSet: y.alwaysSet
        });
      }
      return f;
    }).then((f) => k.mergeObjectSync(r, f)) : k.mergeObjectSync(r, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return h.errToObj, new x({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, r) => {
          var n, i;
          const a = ((i = (n = this._def).errorMap) == null ? void 0 : i.call(n, t, r).message) ?? r.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: h.errToObj(e).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new x({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new x({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new x({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new x({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: m.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new x({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    for (const r of v.objectKeys(e))
      e[r] && this.shape[r] && (t[r] = this.shape[r]);
    return new x({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    for (const r of v.objectKeys(this.shape))
      e[r] || (t[r] = this.shape[r]);
    return new x({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return E(this);
  }
  partial(e) {
    const t = {};
    for (const r of v.objectKeys(this.shape)) {
      const a = this.shape[r];
      e && !e[r] ? t[r] = a : t[r] = a.optional();
    }
    return new x({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    for (const r of v.objectKeys(this.shape))
      if (e && !e[r])
        t[r] = this.shape[r];
      else {
        let n = this.shape[r];
        for (; n instanceof S; )
          n = n._def.innerType;
        t[r] = n;
      }
    return new x({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return Oe(v.objectKeys(this.shape));
  }
}
x.create = (s, e) => new x({
  shape: () => s,
  unknownKeys: "strip",
  catchall: N.create(),
  typeName: m.ZodObject,
  ..._(e)
});
x.strictCreate = (s, e) => new x({
  shape: () => s,
  unknownKeys: "strict",
  catchall: N.create(),
  typeName: m.ZodObject,
  ..._(e)
});
x.lazycreate = (s, e) => new x({
  shape: s,
  unknownKeys: "strip",
  catchall: N.create(),
  typeName: m.ZodObject,
  ..._(e)
});
class q extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = this._def.options;
    function a(n) {
      for (const d of n)
        if (d.result.status === "valid")
          return d.result;
      for (const d of n)
        if (d.result.status === "dirty")
          return t.common.issues.push(...d.ctx.common.issues), d.result;
      const i = n.map((d) => new C(d.ctx.common.issues));
      return c(t, {
        code: o.invalid_union,
        unionErrors: i
      }), p;
    }
    if (t.common.async)
      return Promise.all(r.map(async (n) => {
        const i = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await n._parseAsync({
            data: t.data,
            path: t.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let n;
      const i = [];
      for (const u of r) {
        const f = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, y = u._parseSync({
          data: t.data,
          path: t.path,
          parent: f
        });
        if (y.status === "valid")
          return y;
        y.status === "dirty" && !n && (n = { result: y, ctx: f }), f.common.issues.length && i.push(f.common.issues);
      }
      if (n)
        return t.common.issues.push(...n.ctx.common.issues), n.result;
      const d = i.map((u) => new C(u));
      return c(t, {
        code: o.invalid_union,
        unionErrors: d
      }), p;
    }
  }
  get options() {
    return this._def.options;
  }
}
q.create = (s, e) => new q({
  options: s,
  typeName: m.ZodUnion,
  ..._(e)
});
function ee(s, e) {
  const t = T(s), r = T(e);
  if (s === e)
    return { valid: !0, data: s };
  if (t === l.object && r === l.object) {
    const a = v.objectKeys(e), n = v.objectKeys(s).filter((d) => a.indexOf(d) !== -1), i = { ...s, ...e };
    for (const d of n) {
      const u = ee(s[d], e[d]);
      if (!u.valid)
        return { valid: !1 };
      i[d] = u.data;
    }
    return { valid: !0, data: i };
  } else if (t === l.array && r === l.array) {
    if (s.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let n = 0; n < s.length; n++) {
      const i = s[n], d = e[n], u = ee(i, d);
      if (!u.valid)
        return { valid: !1 };
      a.push(u.data);
    }
    return { valid: !0, data: a };
  } else return t === l.date && r === l.date && +s == +e ? { valid: !0, data: s } : { valid: !1 };
}
class J extends g {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), a = (n, i) => {
      if (ce(n) || ce(i))
        return p;
      const d = ee(n.value, i.value);
      return d.valid ? ((ue(n) || ue(i)) && t.dirty(), { status: t.value, value: d.data }) : (c(r, {
        code: o.invalid_intersection_types
      }), p);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([n, i]) => a(n, i)) : a(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
J.create = (s, e, t) => new J({
  left: s,
  right: e,
  typeName: m.ZodIntersection,
  ..._(t)
});
class R extends g {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.array)
      return c(r, {
        code: o.invalid_type,
        expected: l.array,
        received: r.parsedType
      }), p;
    if (r.data.length < this._def.items.length)
      return c(r, {
        code: o.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), p;
    !this._def.rest && r.data.length > this._def.items.length && (c(r, {
      code: o.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const n = [...r.data].map((i, d) => {
      const u = this._def.items[d] || this._def.rest;
      return u ? u._parse(new A(r, i, r.path, d)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(n).then((i) => k.mergeArray(t, i)) : k.mergeArray(t, n);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new R({
      ...this._def,
      rest: e
    });
  }
}
R.create = (s, e) => {
  if (!Array.isArray(s))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new R({
    items: s,
    typeName: m.ZodTuple,
    rest: null,
    ..._(e)
  });
};
class ge extends g {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.map)
      return c(r, {
        code: o.invalid_type,
        expected: l.map,
        received: r.parsedType
      }), p;
    const a = this._def.keyType, n = this._def.valueType, i = [...r.data.entries()].map(([d, u], f) => ({
      key: a._parse(new A(r, d, r.path, [f, "key"])),
      value: n._parse(new A(r, u, r.path, [f, "value"]))
    }));
    if (r.common.async) {
      const d = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const f = await u.key, y = await u.value;
          if (f.status === "aborted" || y.status === "aborted")
            return p;
          (f.status === "dirty" || y.status === "dirty") && t.dirty(), d.set(f.value, y.value);
        }
        return { status: t.value, value: d };
      });
    } else {
      const d = /* @__PURE__ */ new Map();
      for (const u of i) {
        const f = u.key, y = u.value;
        if (f.status === "aborted" || y.status === "aborted")
          return p;
        (f.status === "dirty" || y.status === "dirty") && t.dirty(), d.set(f.value, y.value);
      }
      return { status: t.value, value: d };
    }
  }
}
ge.create = (s, e, t) => new ge({
  valueType: e,
  keyType: s,
  typeName: m.ZodMap,
  ..._(t)
});
class U extends g {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.set)
      return c(r, {
        code: o.invalid_type,
        expected: l.set,
        received: r.parsedType
      }), p;
    const a = this._def;
    a.minSize !== null && r.data.size < a.minSize.value && (c(r, {
      code: o.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), t.dirty()), a.maxSize !== null && r.data.size > a.maxSize.value && (c(r, {
      code: o.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), t.dirty());
    const n = this._def.valueType;
    function i(u) {
      const f = /* @__PURE__ */ new Set();
      for (const y of u) {
        if (y.status === "aborted")
          return p;
        y.status === "dirty" && t.dirty(), f.add(y.value);
      }
      return { status: t.value, value: f };
    }
    const d = [...r.data.values()].map((u, f) => n._parse(new A(r, u, r.path, f)));
    return r.common.async ? Promise.all(d).then((u) => i(u)) : i(d);
  }
  min(e, t) {
    return new U({
      ...this._def,
      minSize: { value: e, message: h.toString(t) }
    });
  }
  max(e, t) {
    return new U({
      ...this._def,
      maxSize: { value: e, message: h.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
U.create = (s, e) => new U({
  valueType: s,
  minSize: null,
  maxSize: null,
  typeName: m.ZodSet,
  ..._(e)
});
class ve extends g {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
ve.create = (s, e) => new ve({
  getter: s,
  typeName: m.ZodLazy,
  ..._(e)
});
class te extends g {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return c(t, {
        received: t.data,
        code: o.invalid_literal,
        expected: this._def.value
      }), p;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
te.create = (s, e) => new te({
  value: s,
  typeName: m.ZodLiteral,
  ..._(e)
});
function Oe(s, e) {
  return new I({
    values: s,
    typeName: m.ZodEnum,
    ..._(e)
  });
}
class I extends g {
  constructor() {
    super(...arguments), M.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return c(t, {
        expected: v.joinValues(r),
        received: t.parsedType,
        code: o.invalid_type
      }), p;
    }
    if (F(this, M, "f") || we(this, M, new Set(this._def.values), "f"), !F(this, M, "f").has(e.data)) {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return c(t, {
        received: t.data,
        code: o.invalid_enum_value,
        options: r
      }), p;
    }
    return b(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return I.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return I.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...t
    });
  }
}
M = /* @__PURE__ */ new WeakMap();
I.create = Oe;
class xe extends g {
  constructor() {
    super(...arguments), L.set(this, void 0);
  }
  _parse(e) {
    const t = v.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== l.string && r.parsedType !== l.number) {
      const a = v.objectValues(t);
      return c(r, {
        expected: v.joinValues(a),
        received: r.parsedType,
        code: o.invalid_type
      }), p;
    }
    if (F(this, L, "f") || we(this, L, new Set(v.getValidEnumValues(this._def.values)), "f"), !F(this, L, "f").has(e.data)) {
      const a = v.objectValues(t);
      return c(r, {
        received: r.data,
        code: o.invalid_enum_value,
        options: a
      }), p;
    }
    return b(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
L = /* @__PURE__ */ new WeakMap();
xe.create = (s, e) => new xe({
  values: s,
  typeName: m.ZodNativeEnum,
  ..._(e)
});
class G extends g {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== l.promise && t.common.async === !1)
      return c(t, {
        code: o.invalid_type,
        expected: l.promise,
        received: t.parsedType
      }), p;
    const r = t.parsedType === l.promise ? t.data : Promise.resolve(t.data);
    return b(r.then((a) => this._def.type.parseAsync(a, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
G.create = (s, e) => new G({
  type: s,
  typeName: m.ZodPromise,
  ..._(e)
});
class $ extends g {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === m.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), a = this._def.effect || null, n = {
      addIssue: (i) => {
        c(r, i), i.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (n.addIssue = n.addIssue.bind(n), a.type === "preprocess") {
      const i = a.transform(r.data, n);
      if (r.common.async)
        return Promise.resolve(i).then(async (d) => {
          if (t.value === "aborted")
            return p;
          const u = await this._def.schema._parseAsync({
            data: d,
            path: r.path,
            parent: r
          });
          return u.status === "aborted" ? p : u.status === "dirty" || t.value === "dirty" ? P(u.value) : u;
        });
      {
        if (t.value === "aborted")
          return p;
        const d = this._def.schema._parseSync({
          data: i,
          path: r.path,
          parent: r
        });
        return d.status === "aborted" ? p : d.status === "dirty" || t.value === "dirty" ? P(d.value) : d;
      }
    }
    if (a.type === "refinement") {
      const i = (d) => {
        const u = a.refinement(d, n);
        if (r.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return d;
      };
      if (r.common.async === !1) {
        const d = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return d.status === "aborted" ? p : (d.status === "dirty" && t.dirty(), i(d.value), { status: t.value, value: d.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((d) => d.status === "aborted" ? p : (d.status === "dirty" && t.dirty(), i(d.value).then(() => ({ status: t.value, value: d.value }))));
    }
    if (a.type === "transform")
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!j(i))
          return i;
        const d = a.transform(i.value, n);
        if (d instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: d };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((i) => j(i) ? Promise.resolve(a.transform(i.value, n)).then((d) => ({
          status: t.value,
          value: d
        })) : i);
    v.assertNever(a);
  }
}
$.create = (s, e, t) => new $({
  schema: s,
  typeName: m.ZodEffects,
  effect: e,
  ..._(t)
});
$.createWithPreprocess = (s, e, t) => new $({
  schema: e,
  effect: { type: "preprocess", transform: s },
  typeName: m.ZodEffects,
  ..._(t)
});
class S extends g {
  _parse(e) {
    return this._getType(e) === l.undefined ? b(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
S.create = (s, e) => new S({
  innerType: s,
  typeName: m.ZodOptional,
  ..._(e)
});
class V extends g {
  _parse(e) {
    return this._getType(e) === l.null ? b(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
V.create = (s, e) => new V({
  innerType: s,
  typeName: m.ZodNullable,
  ..._(e)
});
class re extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let r = t.data;
    return t.parsedType === l.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
re.create = (s, e) => new re({
  innerType: s,
  typeName: m.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ..._(e)
});
class se extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return B(a) ? a.then((n) => ({
      status: "valid",
      value: n.status === "valid" ? n.value : this._def.catchValue({
        get error() {
          return new C(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new C(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
se.create = (s, e) => new se({
  innerType: s,
  typeName: m.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ..._(e)
});
class ke extends g {
  _parse(e) {
    if (this._getType(e) !== l.nan) {
      const r = this._getOrReturnCtx(e);
      return c(r, {
        code: o.invalid_type,
        expected: l.nan,
        received: r.parsedType
      }), p;
    }
    return { status: "valid", value: e.data };
  }
}
ke.create = (s) => new ke({
  typeName: m.ZodNaN,
  ..._(s)
});
class it extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = t.data;
    return this._def.type._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ne extends g {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const n = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return n.status === "aborted" ? p : n.status === "dirty" ? (t.dirty(), P(n.value)) : this._def.out._parseAsync({
          data: n.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return a.status === "aborted" ? p : a.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, t) {
    return new ne({
      in: e,
      out: t,
      typeName: m.ZodPipeline
    });
  }
}
class ae extends g {
  _parse(e) {
    const t = this._def.innerType._parse(e), r = (a) => (j(a) && (a.value = Object.freeze(a.value)), a);
    return B(t) ? t.then((a) => r(a)) : r(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ae.create = (s, e) => new ae({
  innerType: s,
  typeName: m.ZodReadonly,
  ..._(e)
});
var m;
(function(s) {
  s.ZodString = "ZodString", s.ZodNumber = "ZodNumber", s.ZodNaN = "ZodNaN", s.ZodBigInt = "ZodBigInt", s.ZodBoolean = "ZodBoolean", s.ZodDate = "ZodDate", s.ZodSymbol = "ZodSymbol", s.ZodUndefined = "ZodUndefined", s.ZodNull = "ZodNull", s.ZodAny = "ZodAny", s.ZodUnknown = "ZodUnknown", s.ZodNever = "ZodNever", s.ZodVoid = "ZodVoid", s.ZodArray = "ZodArray", s.ZodObject = "ZodObject", s.ZodUnion = "ZodUnion", s.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", s.ZodIntersection = "ZodIntersection", s.ZodTuple = "ZodTuple", s.ZodRecord = "ZodRecord", s.ZodMap = "ZodMap", s.ZodSet = "ZodSet", s.ZodFunction = "ZodFunction", s.ZodLazy = "ZodLazy", s.ZodLiteral = "ZodLiteral", s.ZodEnum = "ZodEnum", s.ZodEffects = "ZodEffects", s.ZodNativeEnum = "ZodNativeEnum", s.ZodOptional = "ZodOptional", s.ZodNullable = "ZodNullable", s.ZodDefault = "ZodDefault", s.ZodCatch = "ZodCatch", s.ZodPromise = "ZodPromise", s.ZodBranded = "ZodBranded", s.ZodPipeline = "ZodPipeline", s.ZodReadonly = "ZodReadonly";
})(m || (m = {}));
const ft = O.create, ht = K.create;
N.create;
w.create;
const mt = x.create;
q.create;
J.create;
R.create;
const pt = te.create;
I.create;
G.create;
S.create;
V.create;
export {
  ut as M,
  o as Z,
  ct as a,
  ht as b,
  pt as l,
  mt as o,
  ft as s,
  lt as u
};
